import {ValueObject} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'

export class GetVehicleExtrasRequest extends ValueObject {
  #vehicleId
  #field

  static validate({config, vehicleId, field}) {
    if (!vehicleId || !field) {
      throw InvalidParamsSharedError.create(`[GetVehicleExtrasRequest.validate] param vehicleId and field are required`)
    }
    const {VEHICLE_EXTRAS_FIELD} = config.get('vehicles')
    const vehicleExtrasFields = Object.values(VEHICLE_EXTRAS_FIELD)
    if (!vehicleExtrasFields.some(extraField => extraField === field)) {
      throw InvalidParamsSharedError.create(
        `[GetVehicleExtrasRequest.validate] field should be one of ${vehicleExtrasFields.join(', ')}`
      )
    }
  }

  constructor({vehicleId, field}) {
    super()
    this.#vehicleId = vehicleId
    this.#field = field
  }

  static create({config, vehicleId, field}) {
    GetVehicleExtrasRequest.validate({config, vehicleId, field})
    return new GetVehicleExtrasRequest({
      vehicleId,
      field
    })
  }

  toJSON() {
    return {
      vehicleId: this.#vehicleId,
      field: this.#field
    }
  }
}
